import React, { Component } from 'react';
// import DynamicPage from '../dynamic-page';
import DynamicPage from './builder';
import { QuestionDesc } from '../../types';

import './form-item.less';
import { GdImage } from '@gaodun.com/gui-pc';

// 基础组件对照
// const questionTypeToComponent = {
//     "INPUT": "dy-input",
//     "SELECT": "dy-radio",
//     "MULTI_SELECT": "dy-checkbox",
//     "NESTED_SELECT": "dy-cascader",
//     "DATE": "dy-datepicker",
//     "TIME": "dy-datepicker",
//     "DATETIME": "dy-datetime",
// }
const questionTypeToComponent = {
    MULTIPLE_CHOICE: 'dy-checkbox',
    SINGLE_CHOICE: 'dy-radio',
    FILL_IN_BLANK: 'dy-textarea',
};
const nameToComponent = {
    省市区: 'dy-city',
    入学年份: 'dy-datepicker',
    毕业时间: 'dy-datepicker',
    学校: 'dy-school',
    学院: 'dy-school',
    专业: 'dy-school',
    职业状态: 'dy-picker',
    证件类型: 'dy-picker',
    学历: 'dy-picker',
    手机号码: 'dy-input',
    微信号码: 'dy-input',
    邮箱: 'dy-input',
    姓名: 'dy-input',
    国家: 'dy-input',
    证件编码: 'dy-input',
    国际号: 'dy-international-number',
    研究生专业: 'dy-graduate',
    省份: 'dy-province'
};

/**
 * 通过问卷类型和问题名获取对应组件
 * @param qtype 问题类型
 */
export const getComponentByQTypeAndName = (qtype, bizTypeName) => {
    // 如果有自定义组件返回自定义，无则返回基础组件
    return nameToComponent[bizTypeName] || questionTypeToComponent[qtype];
};

export interface Question {
    question: string;
    order: number;
    name: string;
    bizTypeName: string;
    content: string;
    questionType: string;
    selectItemList?: any[];
}

export type CommitFormItemProps = {
    value: any;
    label: string;
    name: string;
    question: Question;
    required?: boolean;
    disabled?: boolean;
    error?: string;
    onChange?: (value) => void;
} & Props;
class CommitFromItem extends Component<CommitFormItemProps, State> {
    constructor(props) {
        super(props);
        this.state = {};
    }

    // 额外参数添加
    getComponentType = type => {
        if (type == 'INPUT') {
            return {
                maxLength: 20,
            };
        }
        return {};
    };

    render() {
        let { className, label, value, question, disabled, onChange } = this.props;
        const componentName = getComponentByQTypeAndName(question.questionType, question.bizTypeName);
        return (
            <div className={`commit-form-item ${className} ${componentName} ${disabled && 'disabled'} `}>
                <div className="commit-form-item-hd">
                    <GdImage
                        className="robot"
                        src="https://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202112/27/7d9c8_20211227135558.gif"
                    />
                </div>
                <div className="commit-form-item-ct">
                    <div className="commit-form-item-q">{label}</div>
                    <div className="commit-form-item-a">
                        {
                            // 动态组件渲染
                            DynamicPage.ComponentRender({
                                // 组件名--必须是已经注册的组件
                                name: componentName,
                                props: {
                                    value,
                                    options: question.selectItemList,
                                    // 这两项特殊处理为年份
                                    ...this.getComponentType(question.bizTypeName),
                                    onChange: onChange,
                                },
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default CommitFromItem;
